import { IRootState } from './index';
import { IVoucherState } from './voucher.types';

export const selectVoucher = ({ voucher }: IRootState): IVoucherState => voucher;
